import React from 'react';
import { CalendarClock } from 'lucide-react';
import ModuleTabHeader from '../../../components/common/ModuleTabHeader';

export type PlanTabKey = 'calendar' | 'leaves_applied' | 'leaves_sanctioned' | 'my_attendance' | 'deadlines';

export interface PlanTabMeta {
  key: PlanTabKey;
  label: string;
}

export const planTabs: PlanTabMeta[] = [
  { key: 'calendar', label: 'Calendar Overview' },
  { key: 'leaves_applied', label: 'Leaves Applied' },
  { key: 'leaves_sanctioned', label: 'Leaves Sanctioned' },
  { key: 'my_attendance', label: 'My Attendance' },
  { key: 'deadlines', label: 'Deadlines' },
];

interface PlanTabsProps {
  activeTab: PlanTabKey;
  onTabChange: (key: PlanTabKey) => void;
  asideOpen: boolean;
  onAsideToggle: () => void;
}

const PlanTabs: React.FC<PlanTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <ModuleTabHeader
      title="Plan"
      icon={<CalendarClock size={16} strokeWidth={1.75} />}
      tabs={planTabs}
      activeTab={activeTab}
      onTabChange={(k: string) => onTabChange(k as PlanTabKey)}
    />
  );
};

export default PlanTabs;
